// extracted by mini-css-extract-plugin
module.exports = {"root":"LeaderboardVFrame_root__ZYUhO","side":"LeaderboardVFrame_side__f_L6E"};